import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import ApiaField from '../ApiaField';
import ApiaForm from '../ApiaForm';
import Field from '../constants/Field';
import { IApiaField } from '../types';
import { getDateFormat } from '../../utils/date';

export interface IInputDatePickerField extends IApiaField {
  setValue(value: string | Date): IInputDatePickerField;
  setDateValueInSeconds(value: number): void;
  getISODate(): string | void;
  getObjectValue(): Date | null;
}

export default class InputDatePickerField
  extends ApiaField
  implements IInputDatePickerField
{
  #dateFormat: string;

  constructor(field: HTMLInputElement, form: ApiaForm) {
    super(field, form, [
      Field.PROPERTY_INPUT_AS_TEXT,
      Field.PROPERTY_REQUIRED,
      Field.PROPERTY_DISABLED,
      Field.PROPERTY_MODAL_DISABLED,
      Field.PROPERTY_READONLY,
      Field.PROPERTY_VISIBILITY_HIDDEN,
      Field.PROPERTY_STORE_MODAL_QUERY_RESULT,
      Field.PROPERTY_TRANSLATION_REQUIRED,
      Field.PROPERTY_SHOW_TOOLTIP_AS_HELP,
    ]);
    dayjs.extend(customParseFormat);
    this.#dateFormat = getDateFormat('d/m/Y');
  }

  setValue(value: string | Date): IInputDatePickerField {
    if (typeof value === 'string') {
      const newDate = dayjs(value, this.#dateFormat, true);
      if (newDate.isValid()) super.setValue(newDate.format(getDateFormat()));
      else super.setValue('');
    } else if (value instanceof Date) {
      if (dayjs(value).isValid()) {
        super.setValue(dayjs(value).format(getDateFormat()));
      }
    }
    return this as IInputDatePickerField;
  }

  setDateValueInSeconds(value: number): void {
    const dateValue: Date = new Date();
    dateValue.setTime(value);
    if (this.#dateFormat)
      this.setValue(dayjs(dateValue).format(this.#dateFormat));
  }

  getISODate(): string | void {
    const date = dayjs(this.getValue() as string, this.#dateFormat, true);
    if (date.isValid()) {
      // const dateIso = date.format('YYYY-MM-DD');
      // return `${dateIso}T00:00:00-00:00`; // '2020-04-04T00:00:00-00:00'
      return date.toISOString();
    }
    throw new Error(`Apia JSApi Error: Wrong format for Date field`);
  }

  getObjectValue(): Date | null {
    if (this.checkFieldExistsInDocument(this.fldId)) {
      if (this.getValue() !== null) {
        const d = dayjs(this.getValue() as string, this.#dateFormat, true);
        if (!d.isValid()) return null;
        return d.toDate();
      }
    }
    return null;
  }
}
